// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Admissions_mainWrapper__QtRXG"};